import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MessageSquare, MessageCircle, Zap, Bot } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const products = [
    { name: 'SMS', path: '/products#sms' },
    { name: 'WhatsApp Business', path: '/products#whatsapp' },
    { name: 'Voice', path: '/products#voice' },
    { name: 'RCS', path: '/products#rcs' },
    { name: 'Email', path: '/products#email' },
    { name: 'Bots', path: '/products#voice-bots' }
  ];

  const industries = [
    'Banking & Finance',
    'NBFC',
    'Retail & E-commerce',
    'D2C Brands',
    'EdTech',
    'Healthcare'
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="h-10 w-10 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold">SB</span>
              </div>
              <span className="text-2xl font-bold text-white">Smartbeeps</span>
            </div>
            <p className="text-slate-400 leading-relaxed">
              Enterprise CPaaS platform powering seamless communication across SMS, WhatsApp, Voice, RCS, Email, and AI Bots.
            </p>
            <div className="space-y-3">
              <a 
                href="mailto:sales@smartbeeps.com" 
                className="flex items-center space-x-2 text-slate-400 hover:text-cyan-400 transition-colors"
              >
                <Mail className="h-5 w-5" />
                <span>sales@smartbeeps.com</span>
              </a>
              <a 
                href="mailto:support@smartbeeps.com" 
                className="flex items-center space-x-2 text-slate-400 hover:text-cyan-400 transition-colors"
              >
                <Mail className="h-5 w-5" />
                <span>support@smartbeeps.com</span>
              </a>
              <a 
                href="tel:+917569820488" 
                className="flex items-center space-x-2 text-slate-400 hover:text-cyan-400 transition-colors"
              >
                <Phone className="h-5 w-5" />
                <span>+91 7569820488</span>
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Products</h3>
            <ul className="space-y-3">
              {products.map((product, index) => (
                <li key={index}>
                  <Link 
                    to={product.path}
                    className="text-slate-400 hover:text-cyan-400 transition-colors inline-block"
                  >
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Industries</h3>
            <ul className="space-y-3">
              {industries.map((industry, index) => (
                <li key={index} className="text-slate-400">
                  {industry}
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-cyan-400 transition-colors inline-block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-slate-400 hover:text-cyan-400 transition-colors inline-block">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-cyan-400 transition-colors inline-block">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-cyan-400 transition-colors inline-block">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-cyan-400 transition-colors inline-block">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} Smartbeeps. All rights reserved.
            </p>
            <p className="text-slate-400 text-sm">
              Powering Communication for Modern Businesses
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;